import axios from 'axios';
import { systemCode, xs_isMobile, xs_languageCode } from '..';
import { splitHandicap } from './splitHandicap';
import { getAmountInCent, getBetAggr, getConfiguration, getPotentialWinning, getTimezoneOffset, roundForCurrency } from './utils';
import $ from 'jquery';

function fakeSuccess(callbackSuccess){
    const fakeResponse = {"returnCode":{"code":0,"flgRetry":false,"description":"ESITO OK","object":null},"responseSystems":null,"responseMultiple":{"proposal":0,"ticketSogei":"DF07E508081465726803","idTerminale":0,"amountWin":604,"betCoupons":[],"importoScommesso":200,"transactionID":1213747385066397,"timeStamp":"20210713T12:41:54","returnCode":{"code":0,"flgRetry":false,"description":"ESITO OK","object":null},"transactionIDString":"1213747385066397","bonusAmount":0,"totalOdd":0,"funBonus":false},"responseSingle":{"proposal":0,"ticketSogei":"DF07E508081465726803","idTerminale":0,"amountWin":604,"betCoupons":[],"importoScommesso":200,"transactionID":1213747385066397,"timeStamp":"20210713T12:41:54","returnCode":{"code":0,"flgRetry":false,"description":"ESITO OK","object":null},"transactionIDString":"1213747385066397","bonusAmount":0,"totalOdd":0,"funBonus":false}};
    setTimeout(() => {
    	callbackSuccess(fakeResponse);
    }, 2000);
}

function fakePurchase(callback){
	 let url = getConfiguration().api.purchase;
	 url = url.replace('purchase', 'fakePurchase');
     $.ajax({
		type: "POST",
		url : url,
		data: null,
        dataType: 'json',
        contentType: "application/json; charset=UTF-8;",
        headers:{
        	'Cache-Control': 'no-transform'
        },
		success : (data) => {
			callback(data);
		},
		error : (errorData) => {
		}	
     });
	 
}


export function checkForSelectionsUpdate(betslipData, frontendType, sessionToken, shopUserData){
    
	let response = {
		returnCode : {
			code : 0
		}
	}
	const shopUserType = shopUserData != null? (shopUserData.operator? 'operator' : 'self-cashier') : null;
	const betslipContainerObject = {
    		frontendType,
    		betslip : betslipData
    };
    const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            token : sessionToken,
            shopUserType
    };
    const url = getConfiguration().api.checkForSelectionsUpdate;
    if(url){
        $.ajax({
    		type: "POST",
    		url : url + "?" +  $.param(params),
    		data: window.encodeURI(JSON.stringify(betslipContainerObject)),
            dataType: 'json',
            contentType: "application/json; charset=UTF-8;",
            headers:{
            	'Cache-Control': 'no-transform'
            },
            async : false,
    		success : (data) => {
    			response = data;
    		}
        });
    }
    
    return response;

}


function getRestoredBetslipDataForLegSystemBet(betslipDataInput){
	const betslipData = JSON.parse(JSON.stringify(betslipDataInput)); // duplicate data
	const coupon = betslipData.coupons[betslipData.selectedCoupon];
	const container = coupon.selectedContainer;
	// each bet with leg = true must have a specic event container, even if we have to replicate it.
	// If for the same event there are both leg = true and leg = false bets (even if our customers tipically avoid this situation by bookmaker)
	// then the "leg=false" can be leave in the same event of "let=true"
	
	if(container === 'systembets' && !betslipData.isPsv){
		const selectionsMap = {};
		for(let ks in coupon.selections){
			const selectionInput = coupon.selections[ks];
			const legBets  = [];
			
			const nonLegBets = [];
			const betsMap = {};
			let betsCounter = 0;
			for(let kb in selectionInput.bets){
				const bet = selectionInput.bets[kb];
				const keyBet = [ bet.scomSogei, bet.handicap].join("_");
				if(!betsMap[keyBet]){
					betsMap[keyBet] = 1;
					betsCounter ++;
				}
				else{
					betsMap[keyBet] = betsMap[keyBet] + 1;
				}
			}
			// if betsCounter == 1, then all the draws here are from the same market. I will handle it as they are NON LEG MARKETS
			
			for(let kb in selectionInput.bets){
				const bet = selectionInput.bets[kb];
				if(bet.legabile && betsCounter > 1){
					legBets.push(bet);
				}
				else{
					nonLegBets.push(bet);
				}
			}

			
			if(legBets.length > 0){
				for(let kl in legBets){
					const selection = JSON.parse(JSON.stringify(selectionInput));
					selection.bets = [];
					selection.bets.push(legBets[kl]);
					const keyFinal = selection.pal + "_" + selection.avv;
					if(!selectionsMap[keyFinal]){
						selectionsMap[keyFinal] = [];
					}
					selectionsMap[keyFinal].push(selection);
				}
			}
			if(nonLegBets.length > 0){
				const keyFinal = selectionInput.pal + "_" + selectionInput.avv;
				if(selectionsMap[keyFinal] && selectionsMap[keyFinal].length > 0){
					// it means that there are a list of duplicated events with just one bet inside it (the legabile one)
					// i can add each nonLegBets here
					const memorizedSelection = selectionsMap[keyFinal][0];
					for(let knl in nonLegBets){
						memorizedSelection.bets.push(nonLegBets[knl])
					}
				}
				else{
					// there are not legabile markets: it is an ordinary selection, I can save it
					selectionsMap[keyFinal] = [];
					selectionsMap[keyFinal].push(selectionInput);
				}
			}
		}
		
		let selections = []; // the final array
		for(let ks in selectionsMap){
			const selectionsList = selectionsMap[ks];
			selections = selections.concat(selectionsList);
		}
		coupon.selections = selections;
	}
	return betslipData;
}

export function getPurchaseResponse(betslipData, 
									selectedFunbonus, 
									selectedFreebet, 
									pvrAccountId, 
									sessionToken, 
									transactionIdAcceptanceForProposal, 
									frontendType,
									shopUserData,
									cf,
									provProfile,
									frontendTransactionId,
									fatherTransactionId,
									callbackSuccess, 
									callbackError) {
	
//	fakePurchase(callbackSuccess);
//	return;
	const conf = getConfiguration();
    const url = conf.api.purchase;
    const betslipContainerObject = {
    		frontendType,
    		betslip : getRestoredBetslipDataForLegSystemBet(betslipData),
    		selectedFunbonus : selectedFunbonus,
    		selectedFreebet : selectedFreebet,
    		pvrAccountId,
    		transactionIdAcceptanceForProposal,
    		cf,
    		provProfile,
    		offsetHours : getTimezoneOffset(),
    		frontendTransactionId,
    		fatherTransactionId
    };
    const shopUserType = shopUserData != null? (shopUserData.operator? 'operator' : 'self-cashier') : null;
    const params = {
        systemCode,
        lingua: xs_languageCode,
        hash: '',
        token : sessionToken,
        shopUserType
    };
    const ajaxTimeout = conf.pffts != null? (conf.pffts) * 1000 : 10000;
    $.ajax({
		type: "POST",
		url : url + "?" +  $.param(params),
		data: window.encodeURI(JSON.stringify(betslipContainerObject)),
        dataType: 'json',
        contentType: "application/json; charset=UTF-8;",
        timeout: ajaxTimeout,
        headers:{
        	'Cache-Control': 'no-transform'
        },
		beforeSend : (jqXHR, settings ) => {
			console.debug("BEFORE SEND getPurchaseResponse [" + frontendTransactionId + "]");
			return true;
		},
		success : (data) => {
			
			if(data){
				console.debug("SUCCESS getPurchaseResponse [" + frontendTransactionId + "] Transaction got a response");

				try {
					console.debug("getPurchaseResponse [" + frontendTransactionId + "] response ["+JSON.stringify(data)+"]");

				}catch(err) {
					console.error(err);
				}
				callbackSuccess(data);			
			}
			else{
				console.error("ERROR getPurchaseResponse [" + frontendTransactionId + "] ha ricevuto risposta null. Attivo il meccanismo di retry");
				if(typeof callbackError === 'function'){
    				callbackError();    		
    			}
			}
		},
		error : (jqXHR, textStatus, errorThrown) => {
			console.error("ERROR getPurchaseResponse [" + frontendTransactionId + "] " + jqXHR?.status + " " + jqXHR?.statusText + " " + textStatus + " " + errorThrown);
			try {
				console.error(JSON.stringify(jqXHR));
			}catch(e) {
			}
			if(typeof callbackError === 'function'){
	    		callbackError();    		
	    	}
		}	
    });
}

export function startCashoutPolling(transactionId, idTicket, finalCallback, errorCallback){
	async function action(callback, failure){
		const url = getConfiguration().api.getScheduledCashoutResponse;    
	    const params = {
	        systemCode,
	        lingua: xs_languageCode,
	        hash: '',
	        idTicket,
	        transactionId
	    };
	    try {
	    	const result = await axios.post(url, null, {params});
	    	callback(result.data);
	    }
	    catch(error){
	    	console.error(error);
	    	if(typeof failure === 'function'){
    			failure(error);    		
    		}
	    }
    }
    setTimeout(() => {
    	action((data) => {
    		if(data.returnCode.code === -9996){
    			// try again
    			startCashoutPolling(transactionId, idTicket, finalCallback, errorCallback);
    		}
    		else {
    			//exit
    			localStorage.removeItem('CASHOUT_REQUEST_DATA');
    			finalCallback(data);
    		}
    	}, 
    	(error) => {
    		if(typeof callbackError === 'function'){
    			errorCallback(error);    		
    		}
    		localStorage.removeItem('CASHOUT_REQUEST_DATA');
    	});
    }, 300);

}

export async function cashoutTicket(sessionToken, idTicket, purchaseAmount, cashoutAmount, tagType, cf, startTimerOperations, callbackSuccess, errorCallback, fatherTransactionId) {

	const url = getConfiguration().api.cashoutTicket;    
    const params = {
        systemCode,
        lingua: xs_languageCode,
        hash: '',
        token : sessionToken,
        idTicket,
        purchaseAmount,
        cashoutAmount,
        tagType,
        cf,
        isMobile : xs_isMobile,
        fatherTransactionId 
    };
  
    try {
        const result = await axios.post(url, null, {params});
        if(result.data.returnCode.code === -9996){
        	// start polling phase
        	const pollingData = result.data.livePurchaseParameters;
        	localStorage.setItem('CASHOUT_REQUEST_DATA', JSON.stringify({...pollingData, idTicket, cashoutAmount}));
        	if(startTimerOperations){
        		startTimerOperations(pollingData);
        	}
        	setTimeout(() => {
        		startCashoutPolling(result.data.livePurchaseParameters.transactionId, idTicket, (response) => {
        			callbackSuccess(response);
        		}, errorCallback);
        	}, result.data.livePurchaseParameters.delay * 1000);
        }
        else{
        	localStorage.removeItem('CASHOUT_REQUEST_DATA');
	        callbackSuccess(result.data);        
        }
    } 
    catch (error) {
    	if(typeof callbackError === 'function'){
    		errorCallback(error);    		
    	}
    	localStorage.removeItem('CASHOUT_REQUEST_DATA');
    }
}

export async function getCashoutableTicket(ticketId, callbackSuccess, callbackError) {

	const url = getConfiguration().api.getCashoutableTicket;    
    const params = {
        systemCode,
        ticketId,
        hash : ''   
    };
    
    try {
        const result = await axios.post(url, null, {params});
        callbackSuccess(result.data);   
    } 
    catch (error) {
    	if(typeof callbackError === 'function'){
    		callbackError(error);    		
    	}
    }
}


export async function checkAcceptance(transactionIdAcceptance, shopUserData, sessionToken, callbackSuccess, callbackError) {
	const conf = getConfiguration();
    const url = conf.api.checkAcceptance;
    const shopUserType = shopUserData != null? (shopUserData.operator? 'operator' : 'self-cashier') : null;
    const params = {
        systemCode,
        lingua: xs_languageCode,
        hash: '',
        token : sessionToken,
        transactionId : transactionIdAcceptance,
        offsetHours : getTimezoneOffset(),
        shopUserType
    };
    const ajaxTimeout = conf.pffts != null? (conf.pffts) * 1000 : 10000;
    try {
        const result = await axios.post(url, null, {params, timeout : ajaxTimeout});
		console.debug(url+ " Transaction " + transactionIdAcceptance + " response: ["+JSON.stringify(result?.data)+"]");
        callbackSuccess(result.data);   
    } 
    catch (error) {
		console.error("Error "+url)
		console.error(error);
    	if(typeof callbackError === 'function'){
    		callbackError(error);    		
    	}
    }
}

export function reserveTicket(coupon, sessionToken, phoneNumber, callbackSuccess, callbackError) {

    const url = getConfiguration().api.reserveTicket;
    const params = {
            systemCode,
            lingua: xs_languageCode,
            phoneNumber,
            hash: '',
            token : sessionToken == null? '' : sessionToken
    };
    $.ajax({
		type: "POST",
		url : url + "?" +  $.param(params),
		data: window.encodeURI(JSON.stringify(coupon)),
        dataType: 'json',
        contentType: "application/json; charset=UTF-8;",
        headers:{
        	'Cache-Control': 'no-transform'
        },
		success : (data) => {
			callbackSuccess(data);
		},
		error : (errorData) => {
	    	if(typeof callbackError === 'function'){
	    		callbackError(errorData);    		
	    	}
		}	
    });
}


export function deleteReservation(reservationCode, sessionToken, deleteFromAccount) {

    const url = getConfiguration().api.deleteReservation;
    const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            sessionToken : sessionToken? sessionToken : '',
            reservationCode,
            deleteFromAccount : deleteFromAccount != null? deleteFromAccount:false
    };
    $.ajax({
		type: "POST",
		url : url,
		data: params,
		success : () => {},
		error : () => {}	
    });
}

export async function reloadReservedTicket(reservationCode, callbackSuccess, callbackError) {

    const url = getConfiguration().api.reloadReservation;
    const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            reservationCode : reservationCode
    };
    
    try {
        const result = await axios.get(url, {params});
        callbackSuccess(result.data);   
    } 
    catch (error) {
    	if(typeof callbackError === 'function'){
    		callbackError(error);    		
    	}
    }
}

export function getTicketData(idTicket, timeout, sessionToken, successCallback, errorCallback){
   	const urlService = getConfiguration().api.getBetslipTicket;
	const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            token : sessionToken,
            idTicket : idTicket,
            offsetHours : getTimezoneOffset()
    };
	$('body').addClass('blur-dialog');
	$.ajax({
		type: "POST",
		url : urlService,
		data: params,
		async : true,
		timeout,
		success : (data) => {
			$('body').removeClass('blur-dialog');
			console.debug("getBetslipTicket response ["+data+"]")
			if(data != null){
				try{
					successCallback(JSON.parse(data));
				}
				catch(e){
					console.error(e);
					$('body').removeClass('blur-dialog');
					if(errorCallback){
						errorCallback();
					}
				}
			}
			else{
				console.debug("getBetslipTicket response is NULL")
				$('body').removeClass('blur-dialog');
				if(errorCallback){
					errorCallback();
				}
			}
		},
		error : (errorData, textStatus, errorThrown) => {
			console.error("Error in calling getBetslipTicket "+textStatus+" "+errorThrown);
			$('body').removeClass('blur-dialog');
			if(errorCallback){
				errorCallback();
			}
		}	
   });
}


export function getStakeTaxed(amount, percentage) {
	percentage /= 100;
	let taxedStake = null;
	const conf = getConfiguration();
	taxedStake = Math.round((amount * percentage) / 100);
	taxedStake = amount - taxedStake;
	taxedStake = taxedStake < 0? 0:taxedStake;
	return taxedStake;
}

export function getStakeTaxedTupleWithPrecision(amount, percentage){
	// since the combination amount with tax could be very small, it could "break" the final stake precision.
	// f.e. 15% tax percentage on 0.1 eq. 0.085, and if we keep two dec digits we will have 0.08
	// if combinations are 20, 0.08 x 20 is 1.60 but the real value should be 1.70
	// to solve this, we multiply 0.085 with 100 (skin multiplier) and x 1000 (precision multiplier)
	// to obtain 8500 and not 8. This obv means that the final stake at the end of the sum must be divided by 1000
	const conf = getConfiguration();
	if(conf.cs.prsy.mod == 0){
		return getStakeTaxed(amount, percentage);
	}
	if(conf.cs.prsy.mod == 1){
		// adding precision
		percentage /= 100;
		const precisionMult = conf.cs.prsy.mult;
		amount = amount * precisionMult;
		const taxValue = Math.round((amount * percentage) / 100);
		let taxedStake = amount - taxValue;
		taxedStake = taxedStake < 0? 0:taxedStake;
		return taxedStake;
	}
	return amount;
}

export function getTaxes(amount, potentialWinningInput, isVirtual){
	let taxesAmount = 0;
	let potentialWinning = potentialWinningInput;
	const conf = getConfiguration();
	const taxWinnings = conf.cs.tw;
	const taxMode = conf.cs.tm;
	const taxWinningsThreshold = conf.cs.twt? conf.cs.twt : 0;
	const coinRoundMode = conf.cs.crm;
	/*const nDec = conf.cs.nd;
	const mult = conf.cs.m;*/
	const minimumAmountUnit = isVirtual? conf.cs.vma.imuv : conf.cs.imu;;
	if(taxesEnabled()){
		const dividend = 10000;
		
		// calculating taxes amount and potentialWinning amount based on the skin taxMode
		if(taxMode == 1){
			if(potentialWinningInput >= taxWinningsThreshold){
				taxesAmount = (potentialWinningInput * taxWinnings) / dividend;
				potentialWinning = potentialWinningInput - taxesAmount;			
			}

		}
		else if((potentialWinningInput - amount) >= taxWinningsThreshold){
			taxesAmount = ((potentialWinningInput - amount) * taxWinnings)/dividend;
			potentialWinning = potentialWinningInput - taxesAmount;
		}
		
		// rounding the values
		if(minimumAmountUnit != 0 && minimumAmountUnit != 1){
			if(coinRoundMode == 0){
				const remaining = potentialWinning % minimumAmountUnit;
				potentialWinning = potentialWinning - remaining;
			}
			else if(coinRoundMode == 1){
				potentialWinning = roundForCurrency(potentialWinning);
			}
			else if(coinRoundMode == 2){
				// NOTHING
			}
		}
		else {
			potentialWinning = roundForCurrency(potentialWinning);
		}
	
	}
	// final calculation
	taxesAmount = potentialWinningInput - potentialWinning;
	return {taxesAmount, potentialWinning};
}

export function taxesEnabled(){
	const conf = getConfiguration();
	const foreignCountry = conf.nas; // out of italy
	const taxWinnings = conf.cs.tw;
	return foreignCountry && taxWinnings > 0;
}



export function getTaxPercentageInteger(){
	let percentage = null;
	if(taxesEnabled()){
		const conf = getConfiguration();
		percentage = conf.cs.tw / 100;
	}
	return percentage;
}

export function getTaxPercentage(){
	let percentage = null;
	if(taxesEnabled()){
		percentage = getTaxPercentageInteger();
		if(percentage){
			percentage = percentage + "%";			
		}
	}
	return percentage;
}

export function getReceiptTaxes(amount, winning, type, totalOdd){
	const conf = getConfiguration();
	let potentialWinningWithoutTaxes = winning;
	let taxes = 0;
	if(type === 'systembets'){
		let percentage = getTaxPercentageInteger();
		if(percentage != null){
			potentialWinningWithoutTaxes = winning / (1 - (percentage/100));
			potentialWinningWithoutTaxes = parseInt(potentialWinningWithoutTaxes);
			taxes = potentialWinningWithoutTaxes - winning;
		}
	}
	else{
		potentialWinningWithoutTaxes = getPotentialWinning((amount / conf.cs.m), totalOdd, conf.cs.nd);
		potentialWinningWithoutTaxes = getAmountInCent(potentialWinningWithoutTaxes, conf.cs.m);
		// taxes amount is the potential winning amount without taxes - the declared potential winning of the receipt
		taxes = potentialWinningWithoutTaxes - winning;
	}
	
	return {
		potentialWinningWithoutTaxes,
		taxes
	}
}

export function getOddsCheckerData(selectionsData, successCallback, errorCallback){
 	const urlService = getConfiguration().api.getOddsCheckerData;
	const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            selectionsData
    };
	$('body').addClass('blur-dialog');
	$.ajax({
		type: "POST",
		url : urlService,
		data: params,
		async : true,
		success : (data) => {
			$('body').removeClass('blur-dialog');
			if(data != null){
				successCallback(JSON.parse(data));
			}
			else{
				errorCallback();
			}
		},
		error : (errorData) => {
			errorCallback();
		}	
   });
}


// input: all the draws selected for a specific event (pal.avv)
// output: true if this set of markets is playable as a multiple bet, false if system bet 
export function playableInMultiple(bets){

	const betMap = {};
	let totalLegMarkets = 0;
	let totalAnagraficMarkets = 0;
	let totalAnagraficMarketsNoDoubled = 0;
	const anagraficIdMap = {};
	for(let k in bets){
		const scomSogei = bets[k].scomSogei;
		const handicap = bets[k].handicap;
		const key = scomSogei + "_" + handicap;
		if(bets[k].legabile && !betMap[key]){
			totalLegMarkets ++;
			if(handicap !== '0'){
				// load handicap type from aggregation
				let set = window.getAggregationAndBetFromBetId(scomSogei, handicap);
				if(!set.market){
					set = window.getAggregationAndBetFromBetId(scomSogei, 0);
				}
				if(set.market && set.market.tipoHandicap !== 0){
					const splittedHandicap = splitHandicap(handicap, set.market.tipoHandicap, null, xs_languageCode);
					if(splittedHandicap.idAnagrafica){
						totalAnagraficMarkets ++;
						const firstAnagraficIdCheckPoint = !anagraficIdMap[splittedHandicap.idAnagrafica];
						let secondAnagraficIdCheckPoint = true;
						if(splittedHandicap.idAnagrafica2){
							// if the spread type is with 2 anagrafic elements 
							// (f.e. type 7, T/T Ronaldo - Messi where Ronaldo has id 1 and Messi id 2), 
							// then I've to check also the second one.
							// if in the betslip we set "T/T Ronaldo - Messi -> Ronaldo" this means that I can't 
							// select in multiple Ronaldo from another spread (f.e. T/T Ronaldo - Suarez) and ALSO that 
							// I can't select Messi.
							
							// TODO: we've to handle in this way also the type 35 and 37, once we we added them in the split handicap flow
							secondAnagraficIdCheckPoint = !anagraficIdMap[splittedHandicap.idAnagrafica2];
						}
						if(firstAnagraficIdCheckPoint && secondAnagraficIdCheckPoint){
							anagraficIdMap[splittedHandicap.idAnagrafica] = true;
							if(splittedHandicap.idAnagrafica2){
								anagraficIdMap[splittedHandicap.idAnagrafica2] = true;
							}
							totalAnagraficMarketsNoDoubled ++;
						}
					}
				}

			}
		}
		betMap[key] = key;
	}
	
	// 1 - all the bets must have an unique key scomSogei_handicap to avoid -> f.e. Ronaldo scores:  yes and Ronaldo scores: no
	// 2 - all the bets must be "legabile". It is enough to check that bets.length == totalLegMarkets because
	//	   totalLegMarkets is incremented just if there is not another bet with the same scomSogei_handicap
	// 3 - if all the bets are "legabile", then we must check if there is not a situation on the same Player, f.e.
	//	   Ronaldo scores 2 goals YES and Ronaldo scores 3 goal Yes (or No) - id anagrafica must be unique in the betslip

	return totalLegMarkets === bets.length && totalAnagraficMarkets === totalAnagraficMarketsNoDoubled;

}


export function getBetBuilderOdd(selection){
	let response = null;
    const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: ''
    };
    const url = getConfiguration().api.getBetBuilderOdd;
    if(url){
        $.ajax({
    		type: "POST",
    		url : url + "?" +  $.param(params),
    		data: window.encodeURI(JSON.stringify(selection)),
            dataType: 'json',
            contentType: "application/json; charset=UTF-8;",
            headers:{
            	'Cache-Control': 'no-transform'
            },
            async : false,
    		success : (data) => {
    			response = data;
    		}
        });
    }
    
    return response;

}

export function getScheduledLivePurchaseTransaction(token, shopUserType, transactionId, successCallback, errorCallback){
	const params = {
        systemCode,
        lingua: xs_languageCode,
        hash: '',
        token,
        shopUserType,
        transactionId,
        offsetHours : getTimezoneOffset()
    };
    const conf = getConfiguration();
    const url = conf.api.getScheduledLivePurchaseTransaction;
    if(url){
    	const ajaxTimeout = conf.pffts != null? (conf.pffts) * 1000 : 10000;
		$.ajax({
			type: "POST",
			url : url,
			data: params,
			timeout : ajaxTimeout,
			async : true,
			success : (data) => {
				if(data != null){
					console.debug("SUCCESS getScheduledLivePurchaseTransaction [" + transactionId + "] got a response");
					try {
						console.debug("getScheduledLivePurchaseTransaction [" + transactionId + "] response ["+data+"]");

					}catch(err) {
						console.error(err);
					}
					try{
						successCallback(JSON.parse(data));
					}
					catch(e){
						console.error(e);
						if(errorCallback){
							errorCallback();
						}
					}
				}
				else{
					console.error("ERROR getScheduledLivePurchaseTransaction [" + transactionId + "] ha ricevuto risposta null");
					if(errorCallback){
						errorCallback();
					}
				}
			},
			error : (errorData, textStatus, errorThrown) => {
				console.error("Error in calling getScheduledLivePurchaseTransaction "+textStatus+" "+errorThrown);
				console.error(errorData);
				if(errorCallback){
					errorCallback();
				}
			}	
	   });
    }
}
